export const ACTION_GET_COUPON_WALLET_LIST = '/promotions/GetCouponWallet';


